import ImageComponent from "common/components/ImageComponent/ImageComponent";
import ImageFromStrapiMedia from "common/components/ImageFromStrapiMedia/ImageFromStrapiMedia";
import { t } from "i18next";
import { BsFeather } from "react-icons/bs";
import TooltipWrapper from "common/components/TooltipWrapper/TooltipWrapper";
import { Animal } from "types/Animal";
import getAnimalLabel from "utils/animalLabel";

type Props = {
  animals: Animal[];
  title?: string;
};

function AnimalItem({ animal }: { animal: Animal }) {
  return (
    <div className="flex px-2">
      <div className="rounded-lg overflow-hidden w-8 h-8 mr-2 mt-1">
        <ImageComponent
          image={
            animal?.picture
              ? ImageFromStrapiMedia(animal?.picture)?.uri
              : undefined
          }
        />
      </div>
      <div className="flex flex-col justify-center flex-1">
        <span className="font-bold text-sm">
          {getAnimalLabel(
            animal?.id,
            animal?.houseName,
            animal?.zimsId,
            animal?.localId,
            animal?.tag
          )}
        </span>
        {animal?.species && (
          <div className="flex items-center gap-1 text-sm">
            <BsFeather className="w-4 h-4" />
            {animal?.species?.scientificName && animal?.species?.name ? (
              <div className="flex flex-row items-center text-sm gap-1">
                <span className="font-bold italic">
                  {animal?.species?.scientificName}
                </span>
                <span className="text-gray-500">{`(${animal?.species?.name})`}</span>
              </div>
            ) : (
              <span>
                {animal?.species?.scientificName ?? animal?.species?.name}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function AnimalListOverview({ animals, title }: Props) {
  return (
    <div className="flex flex-col flex-1 gap-2">
      <h4 className="text-xl font-bold text-primary leading-4">
        {title ?? t("titlePages.animals")}
      </h4>

      <div>
        <TooltipWrapper
          className="mr-1 my-1"
          content={
            animals?.length > 2 ? (
              <div className="grid grid-cols-4 gap-2 overflow-visible">
                {animals?.map((a: Animal) => (
                  <AnimalItem animal={a} />
                ))}
              </div>
            ) : null
          }
        >
          <div className="flex flex-wrap gap-2">
            {animals?.map((a: Animal, index: number) =>
              index < 4 ? <AnimalItem animal={a} /> : null
            )}

            {animals?.length > 4 && (
              <div className="mt-2">
                {t("common.others", {
                  count: (animals?.length || 0) - 4,
                })}
              </div>
            )}
          </div>
        </TooltipWrapper>
      </div>
    </div>
  );
}

export default AnimalListOverview;
